/* Pone las tallas faltantes en el PDP */
(() => {
    console.log('Incomplete Sizes');

    const sizesContent = document.querySelector('.content-tallas');
    const inputSize = document.querySelectorAll('.content-tallas .container-item-talla .input-talla');
    let sizes = [ "H34-M35", "H35-M36", "H36-M37", "H37-M38", "H38-M39", "H39-M40", "H40-M41", "H41-M42", "H42", "H43", "H44", "H45"];
    sizes = sizes.map(size => size.toLowerCase());
    
    // Obtener las tallas disponibles del DOM
    const availableSizes = Array.from(inputSize).map(size => size.value);
    console.log('Tallas disponibles:', availableSizes);

    // Convertir las tallas disponibles a un Set para búsqueda rápida
    const availableSizesSet = new Set(availableSizes);

    // Filtrar las tallas que faltan comparando con las disponibles
    const incompleteSizes = sizes.filter(size => !availableSizesSet.has(size));

    console.log('Tallas faltantes:', incompleteSizes);

    if (incompleteSizes.length > 0 && sizesContent) {
        // Generar el HTML para las tallas faltantes
        const htmls = incompleteSizes.map(size => `
            <div class="container-item-talla" data-sku="">
                <input class="input-talla input-size-validator" type="radio" id="" name="" value="${size}" form="" data-seleccionada="" disabled="disabled">                                        
                <label class="item-talla">${size}</label>                
            </div>
        `);
    
        console.log(htmls);
    
        // Insertar el HTML generado en el DOM
        sizesContent.insertAdjacentHTML('beforeend', htmls.join(''));
    }
    
})();
